import axios from 'axios';

const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || '/api';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120_000, // 2 Minuten – Zyklus kann lange dauern (E-Mail + KI)
  headers: { 'Content-Type': 'application/json' },
});

// --- Token-Cache: Vermeidet JSON.parse bei jedem Request ---
let _cachedToken: string | null = null;

/** Wird vom auth-store aufgerufen wenn sich der Token ändert. */
export function setAuthToken(token: string | null) {
  _cachedToken = token;
}

// Initialen Token aus localStorage laden (einmalig)
if (typeof window !== 'undefined') {
  try {
    const raw = localStorage.getItem('auth-storage');
    if (raw) {
      const parsed = JSON.parse(raw);
      _cachedToken = parsed?.state?.token ?? null;
    }
  } catch {
    // ignorieren
  }
}

// --- Interceptor: Bearer-Token automatisch mitsenden ---
apiClient.interceptors.request.use((config) => {
  if (_cachedToken) {
    config.headers.Authorization = `Bearer ${_cachedToken}`;
  }
  return config;
});

// --- Interceptor: 401 → automatischer Logout ---
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && typeof window !== 'undefined') {
      const url = error.config?.url || '';
      if (!url.includes('/auth/login')) {
        _cachedToken = null;
        localStorage.removeItem('auth-storage');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);
